import { t } from "@lingui/core/macro"
import styles from "./NewMessageLine.module.scss"

export function NewMessageLine() {
    return (
        <div className={styles.newMessageLine} data-testid="new-message-line">
            <div className={styles.line} />
            <span className={styles.text}>{t`New`}</span>
        </div>
    )
}
